module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Sickle_C.55060826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Melee/Item_Weapon_Sickle_C.png
// module id = ./src/assets/item/Weapon/Melee/Item_Weapon_Sickle_C.png
// module chunks = 0